import React from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { BaseReactComponent, Form, FormSubmitButton } from "../../utils/form";
import { API_LIMIT, isModuleExist, START_PAGE, SUPER_ADMIN } from "../../utils/Constant";
import { ComponentHeader, Spinner } from "../common";
import { getSsoUserApi, getSsoViewUserApi } from "./Api";
import { replaceHistory, userRoleType } from "../../utils/ReusableFunctions";
import { postAuthCommonApi } from "../content/Api";
import closeIcon from '../../assets/images/greay-cancel-icon.svg';
import { withRouter } from "../../utils/hoc/withRouter";

class ViewSsoUsers extends BaseReactComponent {
  constructor(props) {
    super(props);

    // const roleType = userRoleType() || SUPER_ADMIN;
    this.state = {

      search: "",
      dummyData: [],
      searchResult: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isLoading: true,
      show: false,
      uploadedFile: null,
      uploading: false
    };
  }

  componentDidMount() {
    const { id } = this.props.match?.params;

    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getSsoViewUserApi(this);
    console.log(this.props.match?.params.id, "props")

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSearch = prevParams.get("search") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";

    if (prevPage !== page || prevSearch !== search) {
      this.setState({ currentPage: page, search }, () => {
        this.props.getSsoViewUserApi(this);

      });
    }
  }


  clearSearch = () => {
    this.onChangeMethod({ search: "" })
  }

  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search)
    })
  }

  getDetailsUser = (rowData) => {

    const { id } = this.props.match?.params
    const type = sessionStorage.setItem("type", "admin")
    this.props.history({
      pathname: `/sso/web-user/details/${this.props.match?.params.id}/${rowData?.id}`,
      state: {
        "id": rowData?.id,
        "ssoPartnerId": this.props.match?.params.id,
        "type": "admin"
      }
    });
  }

  onValidSubmit = async () => {
    const fileData = {
      "data": {
        "ssoPartnerId": this.props?.match.params?.id
      }
    }

    const data = new FormData();
    data.append("file", this.state?.uploadedFile);
    data.append("key", JSON.stringify(fileData));

    this.setState({ uploading: true })
    const res = await postAuthCommonApi(`admin/bulk-user`, data)
    // console.log(res)
    if (res.status == 200) {
      this.setState({ show: false });
      this.setState({ uploading: false });
      this.props.getSsoViewUserApi(this);



    }
    else {
      this.setState({ uploading: false })

    }
  }
  onHide = () => {
    this.setState({ show: false });
  };
  handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the uploaded file
    if (file) {
      this.setState({ uploadedFile: file });
      // console.log("File uploaded:", file);
    }

  };

  render() {

    const { viewList, totalPages, currentPage } = this.props.usersState;
    const { isLoading } = this.state;
    console.log(viewList);
    return (
      <>

        <section className="request-section">
          <ComponentHeader
            title="View Users"
            primaryBtn={"Import"}

            // isSearch={true}
            // placeholder={"Search User"}
            // onChangeMethod={this.onChangeMethod}
            // clearSearch={() => this.clearSearch()}
            isBackArrow={true}
            isReturn={"/partners"}
            handlePrimaryBtn={() => { this.setState({ show: true }) }}

          />
          {/* <CustomTab data={nav_obj} /> */}


          <div className="commom-table-wrapper">
            <CustomTable
              data={isLoading ? [] : viewList?.list || []}
              columns={[

                {
                  width: 250,
                  title: "Full Name",
                  dataIndex: "firstName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      const firstName = rowData.firstName ?? "";
                      const lastName = rowData.lastName ?? "";
                      return `${firstName} ${lastName}`.trim();
                  },
                },
                {
                  width: 250,
                  title: "Email Id",
                  dataIndex: "emailAddress",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.emailAddress || 'Na';
                  },
                },

                {
                  width: 250,
                  title: "Mobile Number",
                  dataIndex: "mobileNumber",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.mobileNumber || 'Na';
                  },
                },
                {
                  width: 250,
                  title: "Company Name",
                  dataIndex: "companyName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.companyName || 'Na';
                  },
                },
                {
                  width: 200,
                  title: "No of Events",
                  dataIndex: "noOfEvent",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.noOfEvent;
                  },
                },
                {
                  width: 350,
                  title: "Subscription Plan Name",
                  dataIndex: "premiumPlanName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        <>
                          {rowData?.premiumPlanName || 'NA'}
                          <br />
                          {rowData?.subPremiumPlanName || 'NA'}
                          <br />
                          {rowData?.subPremiumPlanVariation || 'NA'}
                        </>
                      );
                  },
                },
                {
                  width: 100,
                  title: "Liked",
                  dataIndex: "liked",
                  className: "liked",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.liked;


                  },
                },
                {
                  width: 100,
                  title: "Shared",
                  dataIndex: "shared",
                  className: "shared",
                  isCell: true,
                  render:(text, rowData, dataKey) => {

                      return rowData?.shared;
                  },
                },
                {
                  width: 150,
                  title: "Downloaded",
                  dataIndex: "downloaded",
                  className: "downloaded",
                  isCell: true,
                  render:(text, rowData, dataKey) => {

                      return rowData?.downloaded;

                  },
                },
                {
                  width: 150,
                  title: "Cobrand",
                  dataIndex: "cobrand",
                  className: "cobrand",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.cobrand;


                  },
                },
                {
                  width: 100,
                  title: "Saved",
                  dataIndex: "saved",
                  className: "saved",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.saved;


                  },
                },
                {
                  width: 300,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        <>
                          <Button onClick={() => this.getDetailsUser(rowData)} className="primary-btn inter-medium f-s-14 lh-18">
                            View Detail
                          </Button>

                        </>

                      );
                    
                  },
                },




              ]}
              message="No data found" // For Pagination
              history={this.props.history}
              location={this.props.location}
              total={totalPages}
              currentPage={currentPage}
              loading={this.state.isLoading}
            />

          </div>

        </section>
        <Modal show={this.state.show} onHide={this.onHide} dialogClassName={`custom-modal user-details-modal `}>
          <Modal.Header>
            <Modal.Title className='red-hat-display-bold f-s-20'>{"Upload File"}</Modal.Title>
            <Image src={closeIcon} className='close-icon model-icon-close' alt='icon' onClick={this.onHide} />
          </Modal.Header>

          <Modal.Body>
            <Form onValidSubmit={this.onValidSubmit}>
              <Row>
                <Col sm={12}>
                  <div className="img-upload-wrapper">
                    <input
                      type="file"

                      // id={`carouselUpload${id}`}
                      onChange={this.handleFileChange}
                      accept=".csv"
                    />

                  </div>

                </Col>


              </Row>
              <div className="submit-wrapper" style={{ justifyContent: "center" }}>
                <FormSubmitButton customClass={"primary-btn"} >
                  {this.state.uploading ? <Spinner /> : "Save"}
                </FormSubmitButton>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}


const mapStateToProps = state => ({
  usersState: state.SsoState,
});
const mapDispatchToProps = {
  getSsoViewUserApi

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewSsoUsers));
